export default "__VITE_ASSET__DSANMIJr__"